import Vue from 'www/vue_components'
import vuetify from 'www/modules/vuetify-plugin'
import { initI18n } from 'www/utils'
import I18NextVue from 'i18next-vue'
import SoftVersionIcon from 'www/vue_components/common/SoftVersionIcon/components/desktop/SoftVersionIcon.vue'
import { MOUNT_SELECTOR } from 'www/vue_components/common/SoftVersionIcon/constants'

const mountElement = document.querySelector(MOUNT_SELECTOR)

const mountSideMenu = async () => {
  const { i18next } = await initI18n({ bundle: 'vue_components/common/SoftVersionIcon' })

  Vue.use(I18NextVue, { i18next })

  if (mountElement) {
    new Vue({
      vuetify,
      el: mountElement,
      components: {
        SoftVersionIcon,
      },
    })
  }
}

mountSideMenu()
